import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FC } from 'react';

import { AppRoutes } from './routes/routes';

const theme = createTheme({
  typography: {
    fontFamily: ['Red Hat Display', 'Arial', 'sans-serif'].join(','),
  },
});

export const App: FC<{}> = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
    </ThemeProvider>
  );
};
